<template>
	<fragment>
		<div class="cards card--list row">
			<!-- Filters -->
			<filter-sidebar v-if="filters" v-bind:filters="filters"></filter-sidebar>

			<div v-if="sidebar !== null" class="section-menu col-md-3 order-1 order-md-2">
				<side-menu v-bind:sidebar="sidebar"
						   v-bind:hideChildren="sidebarHideChildren"
						   v-bind:header="sidebarHeader"></side-menu>
			</div>

			<div v-bind:class="sidebar !== null ? 'col-md-9 order-3' : 'col-md-12 order-3'" v-if="listing.length > 0">
				<advocacy-alert-item v-for="(item, index) in listing"
									 v-bind:item="item"
									 v-bind:displaySummary="displaySummary"
									 v-bind:key="item.DetailID"></advocacy-alert-item>

				<section class="pt-3 pb-5 pt-md-4 pb-md-4" v-if="listing.length > 0 && pagination.totalPages > 1">
					<div class="row">
						<div class="col-12">
							<pagination></pagination>
						</div>
					</div>
				</section>

			</div>

			<div class="col-md-9 align-center no-results order-3" v-if="listing.length === 0">
				<h2 class="not-found-heading">Sorry, no items were found matching your specifications.</h2>
				<p>Try removing some filters or searching a different term.</p>
			</div>

		</div>
	</fragment>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex';
	import Pagination from '../components/listing/pagination-dropdown';
	import SideMenu from '../components/layout/side-menu';
	import SummaryItem from '../components/listing/summary-item';
    import AdvocacyAlertItem from '../components/listing/advocacy-alert-item';
    import CardItem from '../components/listing/card-item';
	import FilterSidebar from '../components/listing/filter-sidebar';
	import advocacyAlertFilter from '../filters/advocacy-alert-filter';
	import * as CONST from '../utils/constants';

	export default {
		props: ['filterid', 'filtertype', 'result', 'resource'],
		data: function () {
			return {
				sidebar: CONST.globalProject.SideMenu,
				sidebarHeader: CONST.globalProject.SideMenuHeader,
				sidebarHideChildren: CONST.globalProject.HideSideMenuChildren || false,
                displaySummary: CONST.globalProject.DisplayListingSummary || false,
                displayCardItems: CONST.globalProject.DisplayCardItems || false,
				filters: {}
			}
		},
		computed: mapState({
			loading: state => state.listing.loading,
			listing: state => state.listing.listing,
			pagination: state => state.listing.pagination,
		}),
		components: {
			pagination: Pagination,
            'advocacy-alert-item': AdvocacyAlertItem,
            'card-item': CardItem,
			'side-menu': SideMenu,
			'filter-sidebar': FilterSidebar,
		},
		mounted: function () {
			let _this = this;

			// take props and send to vuex store
			this.setInitData(this.result);
			this.setResource(this.resource);

			// import correct filters for this view based on prop value
			if (this.filtertype === 'advocacyAlertFilter') {
				this.filters = advocacyAlertFilter;
			};

			if (this.hidefilterbar == "true") {
				this.showfilters = false;
			} else {
				this.showfilters = true;
			}

			this.$store.subscribeAction((action, state) => {
				if (action.type === 'listing/setFilter') {
					$('html, body').animate({
						scrollTop: $('.filter-app').offset().top
					}, 1000);
				}
			})

			// if each spec change should trigger a new api call, use this. else manually call setFilter action on button click
			this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'listing/updateSpecification') {
					this.setFilter();
				}
			});
		},
		methods: {
			...mapActions('listing', { setFilter: 'setFilter' }),
			...mapMutations('listing', { setInitData: 'setInitData' }),
			...mapMutations('listing', { setResource: 'setResource' }),

			showCategories: function() {
				if (this.filtertype == 'advocacyAlertWidgetFilter') {
					return true;
				}
				if (this.hidecategories) {
					return false;
				}
				return true;
			},
			contentBackground: function() {
				if (this.filtertype == 'advocacyAlertWidgetFilter') {
					return 'bg-white';
				}
				return 'bg-white';
			},
        },
    }
</script>